<template>
  <div class="main-page">
    <div class="header">
      <img src="../../assets/images/KI logo.svg" alt="logo" />
      <div class="title">{{ uppercase(main_data.app_header.title) }}</div>
      <div class="terms small" @click="goto_url(main_data.app_uslovi_koriscenja.title)">
        {{ main_data.app_terms.title }}
      </div>
      <div class="privacy small" @click="goto_url(main_data.app_politika_privatnosti.title)">
        {{ main_data.app_privacy.title }}
      </div>
      <div class="languages small">
        <span
          :class="{ active: app_language.value === main_data.loc_country.value }"
          @click="app_language.value = main_data.loc_country.value"
          >{{ uppercase(main_data.loc_country.value) }}</span
        >&nbsp;
        <span :class="{ active: app_language.value === 'eng' }" @click="app_language.value = 'eng'">
          {{ uppercase("en") }}
        </span>
      </div>
    </div>
    <div class="body">
      <vue-buttons
        :step_status="icon_status"
        :current_step="current_step"
        @step-changed="change_step"
        class="button-bar"
      ></vue-buttons>
      <vue-location
        v-if="current_step === 0"
        v-bind="$props"
        class="vertical-center"
        @reset-whole-intervention="$emit('reset-whole-intervention')"
        @confirm-step="confirm_step"
        @value-change="$emit('value-change', $event)"
      ></vue-location>
      <div v-else-if="current_step >= 1 && current_step <= 3" class="settings">
        <div class="left">
          <div class="image-container">
            <img
              :src="
                require('../../assets/images/geometrija/desktop_house/KUCE-' + current_house.padStart(2, '0') + '.png')
              "
              alt=""
            />
          </div>

          <div class="text">{{ capitalize(current_title) }}</div>
        </div>
        <div :class="['right', current_step === 3 ? 'maximum' : '']">
          <vue-house
            v-bind="$props"
            v-if="current_step === 1"
            :house_selected="house_selected"
            :initial_setup="initial_setup"
            @confirm-step="confirm_step"
            @back-step="back_step"
            @reset-whole-intervention="$emit('reset-whole-intervention')"
            @set-current-house="set_current_house"
            @value-change="value_change"
          ></vue-house>
          <vue-parameters
            v-bind="$props"
            v-if="current_step === 2"
            :initial_setup="initial_setup"
            @confirm-step="confirm_step"
            @back-step="back_step"
            @reset-whole-intervention="$emit('reset-whole-intervention')"
            @reset-status-data="$emit('reset-status-data')"
            @value-change="$emit('value-change', $event)"
          >
          </vue-parameters>
          <vue-heating
            v-bind="$props"
            v-if="current_step === 3"
            :heating_selected="heating_selected"
            :initial_setup="initial_setup"
            @confirm-step="confirm_step"
            @back-step="back_step"
            @value-change="value_change"
          ></vue-heating>
        </div>
      </div>
      <div class="settings" :style="{ visibility: current_step <= 3 ? 'hidden' : 'visible' }">
        <div class="left position">
          <div class="babylon">
            <div class="babylon-title" ref="babylon_title">
              <span v-if="current_step === 4 || current_step === 5">
                {{ uppercase(main_data.pos_define_positions.title) }}
              </span>
              <span v-if="current_step === 6">
                {{ uppercase(main_data.pos_postojece_proracun.title) }}
              </span>
              <span v-if="current_step >= 7 && current_step <= 12">
                {{ uppercase(main_data.pos_define_interventions.title) }}
              </span>
              <span v-if="current_step == 13">
                {{ uppercase(main_data.calc_final.title) }}
              </span>
            </div>
            <vue-babylon
              class="babylon-house"
              :typ_house_value="main_data.typ_house.value"
              :pos_status_value="main_data.pos_status.value"
              :show_status="current_step === 5 || current_step === 8 || current_step === 9"
              :current_position="current_position"
              :pos_position_select="main_data.pos_position.select"
              @send_methods="send_methods"
              @navigate="set_postojece_screen"
            ></vue-babylon>
          </div>
        </div>
        <div class="right position">
          <vue-info
            v-if="current_step === 4 || current_step === 7"
            v-bind="$props"
            :current_step="current_step"
            @confirm-step="confirm_step"
            @navigate="set_postojece_screen"
            @set-status-data="$emit('set-status-data', $event)"
          ></vue-info>
          <vue-postojece
            v-if="current_step === 5"
            v-bind="$props"
            :current_position="current_position"
            @confirm-step="confirm_step"
            @value-change="$emit('value-change', $event)"
            @set-status-data="$emit('set-status-data', $event)"
          ></vue-postojece>
          <vue-kalkulacija v-if="current_step === 6" v-bind="$props" @confirm-step="confirm_step"></vue-kalkulacija>
          <vue-final
            v-if="current_step >= 8"
            v-bind="$props"
            @confirm-step="confirm_step"
            @back-step="back_step"
            @set-status-data="$emit('set-status-data', $event)"
            @navigate="set_postojece_screen"
            @start-again-desktop="start_again_desktop"
            :ponuda="current_step === 13"
            :current_step="current_step"
            :current_position="current_position"
          ></vue-final>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="left">
        <div class="created">{{ main_data.app_created.title }}</div>
        <div>
          <span class="arhitektura">{{ uppercase(main_data.app_arhitektura.title) }}</span
          >&nbsp;&nbsp;<span class="created">+</span>&nbsp;&nbsp;<span class="arhitektura">{{
            uppercase(main_data.app_piktogram.title)
          }}</span
          >&nbsp;&nbsp;<span class="created">-&nbsp;&nbsp;v{{ verzija }}</span>
          <span style="cursor: pointer;" v-if="settings.export" @click="export_data"
            >&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;export data</span
          >
        </div>
      </div>

      <div class="right">
        KNAUF INSULATION&nbsp;&nbsp;<span class="created"
          >2022&copy;&nbsp;&nbsp;{{ main_data.app_reserved.title }}</span
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  font-size: 1rem;
  color: $text_dark;
  background-color: $main_header;

  .header {
    height: 9.6rem;
    display: flex;
    align-items: center;
    flex: 0 0 9.6rem;
    color: $main_header_light;

    img {
      height: 3.4rem;
      margin: 2.05rem 1.92rem 2.05rem 2.61rem;
      max-height: 3.4rem;
      width: auto;
    }

    .title {
      height: 3.4rem;
      border-left: 2px solid $main_header_light;
      font-size: 1.9rem;
      font-weight: 300;
      padding-left: 1.5rem;
      flex-grow: 1;
      display: flex;
      align-items: center;
    }

    .terms {
      flex: 0 0 auto;
      margin: 0 3rem 0 0;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: white;
        opacity: 0.9;
      }
    }

    .privacy {
      flex: 0 0 auto;
      margin-right: 3.5rem;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: white;
        opacity: 0.9;
      }
    }

    .small {
      font-size: 1.5rem;
      line-height: 1.21;
      letter-spacing: 0.31px;
    }

    .languages {
      // flex: 0 0 auto;
      // font-size: 1.2rem;
      // margin-right: 4rem;
      display: none;

      span {
        cursor: pointer;
      }

      .active {
        color: $text_white;
      }
    }
  }

  .body {
    flex-grow: 1;
    position: relative;
    height: calc(100vh - 14.6rem);
    z-index: 0;

    .button-bar {
      position: absolute;
      z-index: 2;
      left: 3rem;
      top: 50%;
      transform: translateY(-50%);
    }

    .vertical-center {
      height: 100%;
      margin: auto;
    }

    .settings {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;

      .left {
        flex: 0 0 63.8rem;
        max-width: 63.8rem;

        &.position {
          flex: 0 0 77rem;
          max-width: 77rem;
        }

        .image-container {
          width: 63.8rem;
          max-width: 63.8rem;
          height: 57.3rem;
          max-height: 57.3rem;

          img {
            width: 100%;
            max-width: 100%;
            object-fit: contain;
          }
        }

        .text {
          font-size: 3.6rem;
          line-height: 1.17;
          letter-spacing: normal;
          text-align: center;
          color: $text_white;
          margin: -14rem auto 0 auto;
          max-width: 34.6rem;
          min-height: 14rem;
        }

        .babylon-title {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: F-Dem;
          text-align: center;
          font-size: 3.4rem;
          line-height: 1.3;
          color: $text_white;
          margin: 2rem 0;
        }

        .babylon-house {
          height: 100rem;
          max-height: 73vh;
        }
      }

      .right {
        flex: 1 0 auto;
        margin-left: -63.8rem;
        align-self: stretch;

        &.maximum {
          width: 100%;
          max-width: 100%;
        }

        &.position {
          margin-left: 0;
        }
      }
    }
  }

  .footer {
    display: flex;
    height: 4.5rem;
    padding: 0 2.6rem 1.9rem 2.6rem;
    display: flex;
    justify-content: space-between;
    font-family: F-Std;
    font-size: 1.4rem;
    line-height: 1.25;
    color: $text_white;

    .created {
      color: $main_header_light;
    }

    .plus {
      color: $main_header_middle;
    }

    .right {
      display: flex;
      align-items: flex-end;
    }
  }
}
</style>

<script>
import verzija from "../../../data/verzija";
import mixin from "../../lib/mixins.js";
import buttons from "./desktop_buttons.vue";
import location from "./desktop_location.vue";
import house from "./desktop_house.vue";
import parameters from "./desktop_parameters.vue";
import heating from "./desktop_heating.vue";
import babylon from "./desktop_babylon.vue";
import info from "./desktop_info.vue";
import postojece from "./desktop_postojece.vue";
import kalkulacija from "./desktop_kalkulacija.vue";
import final from "./desktop_final.vue";
import superconsole from "../../lib/superconsole";
import settings from "../../Settings";

export default {
  props: [
    "main_data",
    "app_language",
    "app_locales",
    "get_loc_hdd",
    "get_loc_u_max",
    "typ_house_data",
    "get_ordered_construction",
    "get_intervention_exists",
    "get_intervention_20_21_exists",
    "get_intervention_7_exists",
    "get_sklopovi_data",
    "get_final_calculation",
    "get_all_knauf_positions_confirmed",
    "get_knauf_intervention_exists",
    "get_povrsine",
    "get_pos_status_u",
    "export_data",
  ],
  mixins: [mixin],
  components: {
    "vue-buttons": buttons,
    "vue-location": location,
    "vue-house": house,
    "vue-parameters": parameters,
    "vue-heating": heating,
    "vue-babylon": babylon,
    "vue-info": info,
    "vue-postojece": postojece,
    "vue-kalkulacija": kalkulacija,
    "vue-final": final,
  },
  data: function () {
    return {
      icon_status: [true, false, false, false, false],
      verzija: verzija,
      current_step: 0,
      initial_setup: true,
      house_selected: false,
      heating_selected: false,
      previous_step: [],
      current_house: "3",
      current_title: "",
      camera_animation: null,
      current_position: 1,
      settings: settings,
    };
  },
  computed: {
    get_house_array: function () {
      return Object.keys(this.data.typ_house.data);
    },
    all_keys: function () {
      return Object.keys(this.main_data.pos_status.value).filter((elem) => elem != 10 && elem != 13 && elem != 60);
    },
    done_keys: function () {
      return this.all_keys.filter((elem) => this.main_data.pos_status.value[elem].status === 1).length;
    },
  },
  methods: {
    get_screen_name: function (step) {
      const SCREEN_URL = this.get_screen_url(step);
      switch (step) {
        case 0:
          return `${SCREEN_URL} | Location`;
        case 1:
          return `${SCREEN_URL} | House Type`;
        case 2:
          return `${SCREEN_URL} | House Data`;
        case 3:
          return `${SCREEN_URL} | Heating`;
        case 4:
        case 7:
          return `${SCREEN_URL} | Existing State - Progress`;
        case 5:
          return `${SCREEN_URL} | Existing Construction Selection`;
        case 6:
          return `${SCREEN_URL} | Existing State - Calculation`;
        case 8:
          return `${SCREEN_URL} | Intervention`;
        case 9:
          return `${SCREEN_URL} | Intervention - Meterials`;
        case 10:
        case 11:
        case 12:
          return `${SCREEN_URL} | Intervention - Progress`;
        case 13:
          return `${SCREEN_URL} | Offer`;
      }
    },
    get_screen_url: function (step) {
      switch (step) {
        case 0:
          return "#/desktop/location";
        case 1:
          return "#/desktop/geometry/1";
        case 2:
          return "#/desktop/geometry/2";
        case 3:
          return "#/desktop/heating";
        case 4:
        case 7:
          return "#/desktop/existing/progress";
        case 5:
          return "#/desktop/existing/select";
        case 6:
          return "#/desktop/existing/calculation";
        case 8:
          return "#/desktop/intervention";
        case 9:
          return "#/desktop/intervention/materials";
        case 10:
        case 11:
        case 12:
          return "#/desktop/intervention/progress";
        case 13:
          return "#/desktop/offer";
      }
    },
    change_step: function (step) {
      console.log("CHANGE STEP");
      this.previous_step.push({ step: this.current_step, position: this.current_position });
      this.current_step = step;
      this.call_gtag();
    },
    call_gtag: function () {
      let page = this.get_screen_name(this.current_step);
      if (this.current_step === 5 || this.current_step === 8 || this.current_step === 9) {
        page = page + " / " + this.main_data.pos_position.select[this.current_position];
      }
      superconsole.log(page);
      history.pushState({}, "KI kalkulator", window.location.pathname + this.get_screen_url(this.current_step));
      if (typeof gtag !== "undefined") {
        // eslint-disable-next-line
        gtag("config", this.main_data.ga_gtag.value, {
          page_path: page,
        });
      }
    },
    back_step: function (step) {
      console.log("BACK STEP");
      if (this.initial_setup) {
        this.change_step(step - 1);
      } else {
        const prev = this.previous_step.pop();
        if (prev.step === 5 && Object.keys(this.main_data.pos_status.value).indexOf(this.current_position) === -1)
          prev.step = 4;
        this.current_step = prev.step;
        this.call_gtag();
      }
    },
    confirm_step: function (step) {
      if (this.initial_setup) {
        if (step === 2) {
          this.$set(this.icon_status, 1, true);
        } else if (step === 3) {
          this.$set(this.icon_status, 2, true);
          this.initial_setup = false;
        }
        this.change_step(step + 1);
      } else {
        if (step === 5) {
          this.$emit("set-status-data", { value: this.current_position, potvrda: true });
        }
        if (step === 5) {
          this.back_step();
          if (step === 2) {
            this.back_step();
          }
        } else if (step === 0) {
          this.change_step(1);
        } else if (step === 1) {
          this.change_step(2);
        } else if (step === 2) {
          this.change_step(3);
        } else if (step === 3) {
          const prev = this.previous_step[this.previous_step.length - 1].step;
          if (prev <= 2) {
            this.change_step(4);
          } else {
            this.back_step();
            if (step === 2) {
              this.back_step();
            }
          }
        } else if (step === 4) {
          this.$set(this.icon_status, 3, true);
          this.change_step(6);
        } else if (step === 6) {
          this.change_step(7);
        } else if (step === 8) {
          this.change_step(9);
        } else if (step === 9) {
          this.$emit("set-status-data", { value: this.current_position, status: 1 });
          if (this.all_keys.length === this.done_keys) {
            this.change_step(12);
          } else {
            this.change_step(10);
          }
        } else if (step === 10) {
          this.change_step(12);
        } else if (step === 11) {
          this.change_step(7);
        } else if (step === 12) {
          this.change_step(13);
        }
      }
    },
    start_again_desktop: function () {
      // this.initial_setup = true;
      // this.previous_step = [];
      // this.current_step = 0;
      // this.icon_status = [true, false, false, false, false];
      // this.house_selected = false;
      // this.heating_selected = false;
      // this.current_position = 1;
      // this.current_house = "3";
      // this.current_title = "";
      // this.$emit("start-again-desktop");
    },
    value_change: function (event) {
      if (event.name === "typ_house") this.house_selected = true;
      if (event.name === "typ_grejanje") this.heating_selected = true;
      this.$emit("value-change", event);
    },
    set_current_house(event) {
      this.current_house = "" + event.value;
      this.current_title = this.main_data.typ_house.title[event.key];
    },
    send_methods: function (value) {
      if (value["camera_animation"]) {
        this.camera_animation = value.camera_animation;
      }
    },
    set_postojece_screen: function (event) {
      if (event[1] === true) {
        this.camera_animation(this.current_position);
      }
      this.current_position = +event[0];
      if (this.current_step >= 7) {
        this.change_step(8);
      } else {
        this.change_step(5);
      }
    },
    goto_url: function (url) {
      window.open(url, "_blank");
    },
  },
};
</script>
